import { baseApi } from '@/store/api/base.api';

export const vietnamProvinceApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getVietnamProvince: builder.query<any, number>({
			query: (size = 100) => ({
				url: `https://open.oapi.vn/location/provinces?page=0&size=${size}`,
				method: 'GET',
			}),
		}),
	}),
	overrideExisting: true,
});

export const { useGetVietnamProvinceQuery } = vietnamProvinceApi;
